import { useMemo } from 'react';

export function useWealthicaAccountsMemo(wealthicaAccountsRaw: any[] | undefined) {
  const key = useMemo(() => (
    Array.isArray(wealthicaAccountsRaw)
      ? wealthicaAccountsRaw.map((acc: any) => `${acc?.id}:${acc?.balance ?? 0}`).join('|')
      : ''
  ), [wealthicaAccountsRaw]);

  const wealthicaAccounts = useMemo(() => wealthicaAccountsRaw || [], [key]);
  return wealthicaAccounts as any[];
}
